// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentViewHeading-Skeleton_cls1__+XEzB","cls2":"PaymentViewHeading-Skeleton_cls2__6NCWe PaymentViewHeading-Skeleton_cls1__+XEzB"};